module.exports = {
        srcSet: __webpack_public_path__ + "assets/images/races-trophy-ae389eb122cb9f76.png"+" 300w",
        images: [{path: __webpack_public_path__ + "assets/images/races-trophy-ae389eb122cb9f76.png",width: 300,height: 300}],
        src: __webpack_public_path__ + "assets/images/races-trophy-ae389eb122cb9f76.png",
        toString: function(){return __webpack_public_path__ + "assets/images/races-trophy-ae389eb122cb9f76.png"},
        
        width: 300,
        height: 300
      }